import * as yup from "yup";
import ColumnRow from "../components/ColumnRow";
import ValidatedField from "../components/ValidatedField";
import { Formik, Form } from "formik";
import { prepareFormValues, returnFormValues } from "../lib/form";

function VideoForm(props) {
  return (
    <Formik
      initialValues={prepareFormValues({
        url: "",
        name: "",
        description: "",
        videoType: "",
        copyright: "",
        attribution: "",
        source: "",
        priority: "",
        ...props.initialValues,
      })}
      enableReinitialize={props.enableReinitialize}
      onSubmit={(values, ...args) =>
        props.onSubmit(returnFormValues(values), ...args)
      }
      validationSchema={yup.object({
        url: yup.string().url().required(),
        name: yup.string(),
        description: yup.string(),
        videoType: yup.string(),
        copyright: yup.string(),
        attribution: yup.string(),
        source: yup.string(),
        priority: yup.number().integer(),
      })}
    >
      {(formik) => (
        <Form>
          {props.children(
            <>
              <ValidatedField
                formik={formik}
                label="URL"
                name="url"
                type="url"
              />
              <ValidatedField
                formik={formik}
                label="Name"
                name="name"
                type="text"
              />
              <ColumnRow
                columns={[
                  <ValidatedField
                    formik={formik}
                    label="Description"
                    name="description"
                    type="text"
                  />,
                  <ValidatedField
                    formik={formik}
                    label="Video Type"
                    name="videoType"
                    type="text"
                  />,
                ]}
              />
              <ColumnRow
                columns={[
                  <ValidatedField
                    formik={formik}
                    label="Copyright"
                    name="copyright"
                    type="text"
                  />,
                  <ValidatedField
                    formik={formik}
                    label="Attribution"
                    name="attribution"
                    type="text"
                  />,
                ]}
              />
              <ColumnRow
                columns={[
                  <ValidatedField
                    formik={formik}
                    label="Source"
                    name="source"
                    type="text"
                  />,
                  <ValidatedField
                    formik={formik}
                    label="Priority"
                    name="priority"
                    type="text"
                  />,
                ]}
              />
            </>
          )}
        </Form>
      )}
    </Formik>
  );
}

export default VideoForm;
